<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">

    <div class="row mt-1" v-if="alloweditname != true">
      <div class="col-12 custom-medium-text" style="padding-left:10px;">
        {{theName}}
        <button v-show="this.$store.getUserPermissionLevel() > 4 && scheduleid != '-1'" @click="editprocname(true)" type="submit" class="btn pt-0 pb-0"><i class="fa fa-edit" style="font-size:20px;"></i></button>
      </div>
    </div>
    <div class="row mt-1" v-if="alloweditname == true">
      <div class="col-9 pr-1">
        <input class="form-control col-12 pull-left" type="text" id="procedurename" name="procedurename" v-bind:placeholder="$t('enter_procedure_name')" v-model="updatename"></input>
      </div>
      <div class="col-3 px-0">
        <button @click="editprocname(false)" type="submit" class="btn pull-left btn-light mr-1 px-1" style="width:35px"><i class="icon-cross2"></i></button>
        <button @click="saveprocname" type="submit" class="btn skin primary-button pull-left px-1" style="width:35px"><i class="icon-checkmark2"></i></button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 p-0 m-0" style="padding-left:20px;" v-if="procedure.CategoryColour != null">
        <div class="p-2" v-bind:style="{ background: procedure.CategoryColour, color:getTextColor(procedure.CategoryColour) }" style="padding-left:10px;padding-bottom:10px;padding-top:5px;"><span style="font-size:16px; text-transform:uppercase">{{procedure.ProcedureCategoryName}}</span></div>
      </div>
      <div class="col-12 p-0 m-0" style="padding-left: 20px;" v-if="procedure.CategoryColour == null">
        <div class="" style="padding-left: 10px; padding-bottom: 0px; padding-top: 0px;"><span style="font-size:16px; text-transform:uppercase">{{procedure.ProcedureCategoryName}}</span></div>
      </div>
    </div>
    <div v-show="procedure.EnableStatus == true" class="row mt-3">
      <div class="col-12 custom-form-label" style="padding-left: 10px;">
        {{$t('status')}}
      </div>
    </div>
    <div v-show="procedure.EnableStatus == true" class="row mt-1">
      <div class="col-12" style="padding-left: 10px;">
        <select class="form-control settingsdrop" v-model="status" @change="changeStatus">
          <option value="0">{{ $t('created') }}</option>
          <option value="1">{{ $t('started') }}</option>
          <option value="2">{{ $t('done') }}</option>
          <option value="3">{{ $t('verified') }}</option>
          <option value="4">{{ $t('closed') }}</option>
        </select>
      </div>
    </div>

    <div v-show="procedure.EnablePriority == true" class="row mt-3">
      <div class="col-12 custom-form-label" style="padding-left: 10px;">
        {{$t('priority')}}
      </div>
    </div>
    <div v-show="procedure.EnablePriority == true" class="row mt-1">
      <div class="col-12" style="padding-left: 10px;">
        <select class="form-control prioritydrop" v-model="priority" @change="changePriority">
          <option value="0">{{ $t('low') }}</option>
          <option value="1">{{ $t('medium') }}</option>
          <option value="2">{{ $t('high') }}</option>
        </select>
      </div>
    </div>

    <div v-show="procedure.EnableDescription == true || (procedure.IsTask == true && getDescription(description) != '')" class="row mt-3">
      <div class="col-12 custom-form-label" style="padding-left: 10px;">
        {{$t('description')}}
      </div>
    </div>

    <div v-show="procedure.EnableDescription == true" class="row mt-1">
      <div class="col-12">
        <textarea class="form-control" v-model="description" @change="textChanged(el)" v-bind:placeholder="$t('aditional_notes')"></textarea>
      </div>
    </div>

    <div v-show="!(procedure.EnableDescription == true) && getDescription(description) != ''" class="row mt-2">
      <div class="col-12">
        <span v-html="getDescription(description)"></span>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: "procedureschedule-settings",
    components: {

    },
    props: {
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        procedureSchedule: {},
        status : 0,
        description : '',
        theName : '',
        activeColor: 'red',
        fontSize: 30,
        priority : 0,
        updatename: '',
        alloweditname: false,
      };
    },
    computed: {

      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 24");
          this.$store.commit('saveprocedure', value)
        }
      }

    },
    methods: {
      onChange() {
        this.$store.markAsChanged();
      },
      setProcedureScheduleData(name, prio, status, allowEditPriority, allowEditStatus, allowEditDescription) {
        this.theName = name;
        this.updatename = name;
        this.priority = prio;
        this.status = status;
        this.allowEditPriority = allowEditPriority;
        this.allowEditStatus = allowEditStatus;
        this.allowEditDescription = allowEditDescription;
      },
      saveprocname() {
        try {
          var data = {
            id: this.scheduleid,
            name: this.updatename
          };
          var url = '/api/Procedure/UpdateProcedureScheduleName';
          this.$http.post(url, data).then(async response => {
            //alert('doSearch12')
            //alert("3 setting names to " + response.data.name)
            this.theName = response.data.name;
            this.updatename = response.data.name;
            this.editprocname(false);
            //this.$forceUpdate();
            vm.$root.$emit('doSearch');

          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      editprocname(allow) {
        this.alloweditname = allow;
        this.$forceUpdate();
      },
      changePriority() {
        this.updateProcedureSchedule();
        this.onChange(null);
      },
      changeStatus() {
        this.updateProcedureSchedule();
        this.onChange(null);
      },

      getTextColor(color) {
        if (color == null || typeof (color) == "undefined")
          return "black"
        else if (ColorUtils.isLight(color)) {
          return "black"
        }
        return "white"
      },
      handleRefresh(val) {
        
        this.alloweditname = false;
        //alert("handleRefresh with:" + val.ProcedureScheduleName)

        this.description = val.ScheduleWorkNote;//Description;

        if (this.scheduleid < 0 || this.scheduleid === undefined
          || this.scheduleid === "") {
          //alert("4 setting names to " + val.ProcedureName)

          this.theName = val.ProcedureName
          this.updatename = val.ProcedureName
        }
        else {
          //alert("5 setting names to " + val.ProcedureScheduleName)
          this.theName = val.ProcedureScheduleName
          this.updatename = val.ProcedureScheduleName
        }

        this.priority = val.Priority;
        this.status = val.Status;

        this.$forceUpdate();

        var thisContext = this;
        setTimeout(function () {
          //$('.settingsdrop').select2();
          //$('.settingsdrop').val(thisContext.status).trigger("change");

          //$('.prioritydrop').select2();
          //$('.prioritydrop').val(thisContext.priority).trigger("change");
        }, 5);

       

       
      },
    
      updateProcedureSchedule() {
        try {
          var data = {
            id: this.procedureSchedule.id,
            status: this.status,
            priority: this.priority,
            name: this.theName,
            description: this.description
          };
          //console.log("UpdateProcedureSchedule:" + JSON.stringify(data))
          var url = '/api/Procedure/UpdateProcedureSchedule';
          this.$http.post(url, data).then(async response => {
            //alert('doSearch12')
            vm.$root.$emit('doSearch');
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      descriptionChanged() {
        this.updateProcedureSchedule();
        this.onChange(null);
      },
      nameChanged() {
        this.updateProcedureSchedule();
        this.onChange(null);
      },
      getDescription(description) {
        if (typeof (description) != 'undefined' && description != null && description != '')
          return description.replace(/\n/g, '</br>')
        return "";
      },
      textChanged(el) {
        this.updateProcedureSchedule();
        this.onChange(null);
      },      
    },
    mounted() {

      //$('.settingsdrop').select2();
      //alert("this.procedure.Description:" + this.procedure.Description)
      //this.theName = this.procedure.ProcedureName;
      //this.description = this.procedure.Description;
    },

    watch: {
      scheduleid: function (newVal, oldVal) {
        //this.theName = newVal.ProcedureScheduleName;
        //this.getData(newVal);
      },
      status: function (newVal, oldVal) {
        //this.updateProcedureSchedule();
      },
      priority: function (newVal, oldVal) {
        //this.updateProcedureSchedule();
      },
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedureschedule-settings.vue